import type { FC } from 'react';

import { useGetAcceptanceById } from '@/hooks/queries';

type Props = {
  acceptanceId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ acceptanceId }) => {
  const { data } = useGetAcceptanceById(acceptanceId ?? '', !acceptanceId);

  return <>{data?.acceptance?.[0]?.Title || ''}</>;
};

export default Breadcrumb;
